"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeMasterPageRefs = decodeMasterPageRefs;
const decoded_types_1 = require("../decoded-types");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const entity_list_1 = require("./entity-list");
function decodeMasterPageRefs(slot, path, warnings) {
    if (slot === undefined) {
        return [];
    }
    if (slot.type !== 'container' && slot.type !== 'econtainer') {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `expected container for Root[6], got ${slot.type}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return [];
    }
    const detected = (0, entity_list_1.detectEntityList)(slot.children);
    if (detected === null) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `Root[6] does not open with (count, typeCode)`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return [];
    }
    if (detected.typeCode !== '6') {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnknownTypeCode,
            message: `expected Root[6] typeCode=6, found ${detected.typeCode}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return [];
    }
    const out = [];
    const items = (0, entity_list_1.entityListItems)(slot);
    for (const [idx, item] of items.entries()) {
        const itemPath = `${path}/items[${idx}]`;
        if (item.type !== 'text') {
            warnings.push({
                type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
                message: `expected text row in Root[6], got ${item.type}`,
                severity: sigma_engine_shared_1.BoundaryLevel.Warning,
                path: itemPath,
            });
            continue;
        }
        const parsed = parsePageRefRow(item.content);
        if (parsed === null) {
            warnings.push({
                type: decoded_types_1.DecodeWarningType.InvariantViolation,
                message: `Root[6] row has fewer than 3 whitespace-separated fields: ${JSON.stringify(item.content)}`,
                severity: sigma_engine_shared_1.BoundaryLevel.Error,
                path: itemPath,
            });
            continue;
        }
        out.push({ kind: 'master-page-ref', ...parsed, raw: item });
    }
    if (out.length !== detected.declaredCount) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.InvariantViolation,
            message: `Root[6] declared count=${detected.declaredCount} but decoded ${out.length} rows`,
            severity: sigma_engine_shared_1.BoundaryLevel.Error,
            path,
        });
    }
    return out;
}
function parsePageRefRow(text) {
    const trimmed = text.trim();
    if (trimmed.length === 0) {
        return null;
    }
    const tokens = trimmed.split(/\s+/);
    if (tokens.length < 3) {
        return null;
    }
    const pageNum = tokens[tokens.length - 1];
    const pageFile = tokens[tokens.length - 2];
    const pageName = tokens.slice(0, tokens.length - 2).join(' ');
    return { pageName, pageFile, pageNum };
}
//# sourceMappingURL=decode-master-page-ref.js.map